<template>
  <div ref="rootNode" class="app-notifications" @click="clicked">
    <header>
      <div class="unread-count">
        {{ unread }}
      </div>
      <h1>{{ $t('notifications.new-unread') }}</h1>
    </header>
    <ul class="notifications-list">
      <li v-for="notification of latestNotifications" :key="notification.id">
        <div v-if="!notification.read" class="unread-circle"></div>
        <div
          class="notification-body"
          v-html="getNotificationBody(notification)"
        ></div>
        <div class="notification-time">
          {{ $t('date.ago', { time: getTimeDistance(notification) }) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import { decamelize } from 'humps'
import frLocale from 'date-fns/locale/fr'
import debounce from 'lodash/debounce'

export default {
  name: 'AppNotifications',

  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    opened() {
      if (this.opened) {
        this.read()
      }
    }
  },

  computed: {
    ...mapState('notifications', {
      latestNotifications: ({ newList }) => newList.slice(0, 20)
    }),

    ...mapGetters({
      unread: 'notifications/unread'
    })
  },

  methods: {
    getNotificationBody(notification) {
      if (notification.type === 'default') {
        return notification.payload.body
      }
      switch (notification.event) {
        case 'connectionSuccessful':
          return this.$t(
            `toast.connection-successful${
              notification.payload.location.city ? '' : '-no-location'
            }`,
            {
              ...notification.payload.location,
              ...notification.payload.userAgent,
              ip: notification.payload.ip
            }
          )
        default:
          return this.$t(
            `toast.${decamelize(notification.event, { separator: '-' })}`,
            notification.payload
          )
      }
    },

    getTimeDistance(notification) {
      return distanceInWordsToNow(notification.createdAt, {
        locale: frLocale
      })
    },

    read: debounce(
      function() {
        const unread = this.latestNotifications
          .filter(
            notification =>
              !notification.read &&
              notification.payload &&
              notification.payload.notificationId
          )
          .map(({ payload }) => payload.notificationId)

        if (unread.length) {
          this.readNotifications(unread)
        }
      },
      400,
      {
        leading: true
      }
    ),

    clicked() {
      // this.$router.push({
      //   name: 'user-notifications'
      // })
    },
    ...mapActions({
      readNotifications: 'notifications/read'
    })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.notification-body strong {
  color: map_get($palette-primary, main);
}
</style>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.app-notifications {
  /*cursor: pointer;*/
  overflow: hidden;
  background-color: white;
  width: 30rem;
  border-radius: 4px;
  color: $color-galaxy;
  box-shadow: 0px 1px 6px 0 rgba(0, 0, 0, 0.15);
}

.notifications-list {
  max-height: 40rem;
  overflow: auto;

  & > li {
    position: relative;
    padding: 2rem 3rem 2rem 4rem;

    &:not(:first-child) {
      border-top: 1px solid $color-diamond;
    }
  }
}

.notification-body {
  font-size: 1.4rem;
  font-weight: 600;

  strong {
    color: map_get($palette-primary, main);
  }
}

.notification-time {
  margin-top: 1.2rem;
  font-size: 1.2rem;
  color: $color-daddy;
}

.unread-circle {
  position: absolute;
  top: 2.4rem;
  left: 1.8rem;
  width: 1rem;
  height: 1rem;
  background-color: map_get($palette-primary, main);
  border-radius: 50%;
}

header {
  display: flex;
  align-items: center;
  background-color: map_get($palette-primary, main);
  padding: 2rem;
  font-size: 1.6rem;
  color: white;

  h1 {
    margin-left: 1.3rem;
  }

  .unread-count {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 50%;
    background-color: white;
    color: map_get($palette-primary, main);
  }
}
</style>
